import React, { useState, useEffect } from 'react';
import {
  ArrowRight,
  CheckCircle,
  Info,
  Sparkles,
  Rocket,
  Package,
  Handshake,
  Users
} from 'lucide-react';

export default function TradingAccount() {
  const [showWhy, setShowWhy] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const steps = [
    'Inscris-toi sur RaiseFX en cliquant sur "Ouvrir un compte de trading en 5 min".',
    'Complète tes informations, sélectionne MT5-EUR et clique sur « Proceed ».',
    'Envoie tes documents pour valider ton compte avant de déposer.',
    'Rejoins notre Discord pour confirmer ton inscription et activer l’accès.',
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-purple-900/20 via-black/70 to-black/70 pt-32 pb-20 overflow-y-auto snap-y snap-mandatory">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 space-y-16">

        {/* HEADER */}
        <header className="text-center snap-start animate-fade-up">
          <h1 className="text-4xl sm:text-5xl font-extrabold text-white mb-4">
            DERNIÈRE ÉTAPE
          </h1>
          <p className="text-lg sm:text-xl text-gray-200 max-w-2xl mx-auto">
            Créé ton compte de trading pour débloquer tous les avantages privés.
          </p>
        </header>

        {/* CARD CENTRÉE */}
        <div className="flex justify-center">
          <div className="w-full max-w-xl relative">
            <div className="absolute inset-0.5 bg-gradient-to-br from-green-600 to-teal-600 rounded-2xl blur opacity-10 pointer-events-none" />

            <div className="relative bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-green-400 shadow-xl flex flex-col">

              <div className="flex flex-col items-center text-center gap-2 mb-6">
                <h2 className="text-2xl sm:text-3xl font-extrabold text-white">
                  Créé ton compte de trading
                </h2>
                <p className="text-gray-100 text-base mt-1 max-w-3xl">
                  Profite de l’accès complet : formation vidéo avancée + alertes en temps réel,
                  le tout gratuitement. Idéal pour les débutants comme les confirmés.
                </p>
                <div className="mt-2 flex items-center gap-2">
                  <button
                    className="flex items-center justify-center w-4 h-4 text-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                    onClick={() => setShowWhy(prev => !prev)}
                  >
                    <Info className="w-4 h-4 cursor-pointer" />
                  </button>
                </div>
                {showWhy && (
                  <p className="mt-2 text-gray-100 text-sm bg-white/10 p-2 rounded-md max-w-xs backdrop-blur-sm">
                    Pour garantir que tu reçoives tes alertes et modules privés sans délai,
                    nous vérifions que ton compte trader est bien actif chez notre partenaire.
                  </p>
                )}
              </div>

              {/* BÉNÉFICES */}
              <div className="mb-8 flex-shrink-0">
                <h3 className="text-xl sm:text-2xl font-bold text-white text-center mb-4">
                  Ce que tu débloques
                </h3>
                <ul className="space-y-3 ml-8">
                  {[ 
                    'Accès à la formation gratuite',
                    'Accès aux alertes de trading',
                    'Modules vidéo privés',
                    'Suivi et coaching personnalisé',
                    'PDF exclusif “Comment faire grossir un petit compte”',
                    'Communauté privée sur Discord'
                  ].map((item, i) => (
                    <li key={i} className="flex items-center gap-3">
                      <CheckCircle className="w-6 h-6 text-green-400 flex-shrink-0" />
                      <span className="text-gray-100 text-base">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* CTA */}
              <div className="mt-auto flex flex-col items-center gap-2">
                <a
                  href="https://partners.raisefx.com/visit/?bta=134764&brand=raisefx"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-10 py-3 bg-green-500 hover:bg-green-600 transition-colors duration-300 rounded-xl shadow-lg font-bold text-lg min-w-[260px] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                >
                  Ouvrir un compte de trading en 5 min
                  <ArrowRight className="w-5 h-5" />
                </a>
                <p className="text-gray-300 text-xs">
                  Accès immédiat au Discord privé dès validation.
                </p>
              </div>

              <div className="mt-8 mb-2 border-t border-green-400/30"></div>
              <div className="mb-4 text-center">
                <h3 className="text-xl font-bold text-white">Instructions d’inscription</h3>
              </div>

              <div className="space-y-2 text-sm text-gray-200">
                <ol className="list-decimal list-inside space-y-2">
                  {steps.map((step, index) => (
                    <li key={index} className="px-2">{step}</li>
                  ))}
                </ol>
              </div>
            </div>
          </div>
        </div>

        {/* FOOTER */}
        <footer className="flex flex-col items-center gap-4 snap-end pb-10 animate-fade-up">
          <div className="flex items-center gap-3">
            <div className="w-3 h-3 rounded-full bg-green-500"></div>
            <div className="w-12 h-0.5 bg-green-500"></div>
            <div className="w-3 h-3 rounded-full bg-green-500"></div>
          </div>
          <p className="text-gray-400 text-sm">Étape 2 sur 2</p>
        </footer>
      </div>
    </div>
  );
}
